(ns dashboard.views.analysis.synchronization.subs
  (:require [re-frame.core :as rf]
            [dashboard.views.analysis.synchronization.config :as config]))

(rf/reg-sub
  ::my-structured-analyses
  (fn [db _]
    (get-in db [:structured-analyses :data])))

(rf/reg-sub
  ::removed-template-questionnaires
  (fn [db _]
    (get-in db [:master-synchronization-state :data :removed-template-questionnaires])))

(rf/reg-sub
  ::master-synchronization-state
  (fn [db _]
    (get-in db [:master-synchronization-state :data])))

(rf/reg-sub
 ::is-synchronizing
 (fn [db [_]]
   (get-in db [config/app-db-key :synchronizing?])))

(rf/reg-sub
  ::synchronized-structured-analyses-loading
  (fn [db _]
    (get-in db [:master-synchronization-state :loading])))

(defn synchronized-analyses-by-id [db]
  (let [structured-analyses (get-in db [:master-synchronization-state :data :structured-analyses])
        analyses-by-id (->> structured-analyses
                            (sort-by :structured-analysis-id)
                            (reverse)
                            (group-by :construct-id))]
    analyses-by-id))

(rf/reg-sub
  ::synchronized-structured-analyses-data
  (fn [db _]
    (synchronized-analyses-by-id db)))

(rf/reg-sub
 ::is-committing
 (fn [db [_]]
   (get-in db [config/app-db-key :committing?] false)))
